import { Pipe, PipeTransform } from '@angular/core';
import { isString } from '@shared/functions/is-string';

@Pipe({
    name: 'stripEmptyDateTime',
    standalone: false
})
export class StripEmptyDateTimePipe implements PipeTransform {
    transform(value: any, args?: any): any {
        return isString(value) ? value.replace(', 00:00:00', '') : '';
    }
}
